import axios from "axios";
import settings from "../../settings";

axios.defaults.baseURL = settings.baseUrl;

export const getContacts = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("Contact")
      .then(resp => {
        const response = resp.data;
        commit("SET_CONTACTS", response);
        resolve(response);
      })
      .catch(err => {
        commit("SET_CONTACTS", []);
        reject(err);
      });
  });
};

export const getContactById = (_, contactId) => {
  return new Promise((resolve, reject) => {
    axios
      .get("Contact/" + contactId)
      .then(resp => {
        resolve(resp.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const addContact = (_, params) => {
  return new Promise((resolve, reject) => {
    axios
      .post("Contact", {
        name: params.name,
        email: params.email,
        cardId: params.cardId,
        phoneNumber: params.phoneNumber,
        teamId: params.teamId
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateContact = (_, params) => {
  return new Promise((resolve, reject) => {
    axios
      .put("Contact/" + params.contactId, {
        name: params.name,
        email: params.email,
        cardId: params.cardId,
        phoneNumber: params.phoneNumber
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteContact = (_, contactId) => {
  return new Promise((resolve, reject) => {
    axios
      .delete("Contact/" + contactId)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};
